import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'

export default function useToast() {
  const toastAlert = ({
    title = 'Error!',
    icon = 'XIcon',
    variant = 'error',
    text = '',
  }) => (
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title,
        icon,
        variant,
        text,
      },
    })
  )

  return {
    toastAlert,
  }
}
